module.exports = __webpack_public_path__ + "static/media/slide1.77cb3acb.jpg";